import type { ExtractPropTypes } from "vue";

import type TimelineRuler from "./timeline-ruler.vue";

export const TimelineRulerProps = {
  /**
   * 起始时间（Date 对象）
   */
  startTime: {
    type: Date,
    default: null,
  },
  /**
   * 持续时长（秒）
   */
  duration: {
    type: Number,
    default: 3600,
  },
  /**
   * 当前播放位置（毫秒时间戳），由外部同步
   */
  currentTimeMs: {
    type: Number,
    default: null,
  },
};

export type TimelineRulerPropsType = ExtractPropTypes<
  typeof TimelineRulerProps
>;
export type TimelineRulerInstance = InstanceType<typeof TimelineRuler>;

/** 刻度配置项 */
export interface TickCfg {
  iv: number;
  h: number;
  w: number;
  c: string;
  lbl?: boolean;
}
